import React, { useEffect, useState } from 'react';
import { Button, Grid, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '../common/Modal';
import { useExercise } from './hooks/useExercise';
import Steps from '../common/Steps';
import { ExerciseInfo } from './ExerciseInfo';
import { RoleplayConfig } from './RoleplayConfig';
import { SuggestedJourney } from './SuggestedJourneys';
import { INITIAL_EXERCISE_INFO, INITIAL_OVERVIEW } from './contants';

const useStyle = makeStyles({
  popupContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  header: {
    fontWeight: '600',
    fontSize: '18px',
    padding: '0px 10px',
  },
  content: {
    height: '65vh',
    overflowY: 'auto',
    background: '#f3f4f7',
    padding: '20px 10px',
  },
  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  option_field: {
    color: '#667085',
  },
  inputField: {
    width: '97%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: 'white',
    fontSize: '14px',
  },
});

export const ExercisePopup = ({ isOpen, setIsOpen, isEdit }) => {
  const classes = useStyle();

  const [exerciseInfo, setExerciseInfo] = useState(INITIAL_EXERCISE_INFO);
  const [overView, setOverView] = useState([INITIAL_OVERVIEW()]);
  const [imageData, setImageDataa] = useState();
  const [thumbnail, setThumbnaill] = useState('');
  const [thumbnailImg, setThumbnailImg] = useState(null);
  const [selectedJourneys, setSelectedJourneys] = useState([]);

  const { step, setStep, handleNext, resetAll, getExerciseInfo } = useExercise();

  const handleChange = (e, type, limit) => {
    const input = e.target.value;
    const { checked } = e.target;

    // Handle reportingParameters array
    if (type === 'reportingParameters') {
      setExerciseInfo((pre) => ({
        ...pre,
        [type]: input,
      }));
      return;
    }

    const numberTypes = ['timeLimit'];
    const isAllowedType = numberTypes.includes(type);
    const newValue = isAllowedType ? input.replace(/\D/g, '') : input;

    if (limit && newValue.length > limit) return;
    if (type === 'showTranscript') {
      setExerciseInfo((pre) => ({
        ...pre,
        [type]: checked,
      }));
      return;
    }
    setExerciseInfo((pre) => ({
      ...pre,
      [type]: newValue,
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setImageDataa(file);
    const reader = new global.FileReader();
    reader.onload = (ev) => {
      setThumbnailImg(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteThumbnail = () => {
    setImageDataa(undefined);
    setThumbnaill('');
    setThumbnailImg(null);
  };

  const handleClose = () => {
    setIsOpen(false);
    resetAll();
  };

  useEffect(() => {
    if (isEdit) {
      getExerciseInfo(setExerciseInfo, setOverView, setThumbnaill, setSelectedJourneys);
    }
  }, []);

  const onNext = () => {
    handleNext(exerciseInfo, overView, imageData, selectedJourneys, setIsOpen, isEdit);
  };

  const handleAddOverview = () => {
    const temp = [...overView];
    temp.push(INITIAL_OVERVIEW());
    setOverView(temp);
  };

  const handleChangeOverview = (e, limit, indx) => {
    const input = e.target.value;
    if (input.length > limit) return;
    const temp = [...overView];
    temp[indx].text = input;
    setOverView(temp);
  };

  const handleRemove = (indx) => {
    const temp = [...overView];
    temp.splice(indx, 1);
    setOverView(temp);
  };

  return (
    <Modal isOpen={isOpen} height="85vh" width="70vw">
      <Grid className={classes.popupContainer}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Grid item className={classes.header}>
              {isEdit ? 'Edit Exercise' : 'Add Exercise'}
            </Grid>
          </Grid>
          <Grid item>
            <CloseIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        <Steps step={step} stepInfo={['Exercise Info', 'Roleplay Configuration', 'Suggested Journeys']} />

        <Grid container className={classes.content}>
          {step === 1 && (
            <ExerciseInfo
              exerciseInfo={exerciseInfo}
              setExerciseInfo={setExerciseInfo}
              handleChange={handleChange}
              handleImageUpload={handleImageUpload}
              handleDeleteThumbnail={handleDeleteThumbnail}
              imageData={imageData}
              thumbnail={thumbnail}
              thumbnailImg={thumbnailImg}
              overView={overView}
              handleAddOverview={handleAddOverview}
              handleChangeOverview={handleChangeOverview}
              handleRemove={handleRemove}
            />
          )}
          {step === 2 && <RoleplayConfig exerciseInfo={exerciseInfo} handleChange={handleChange} />}
          {step === 3 && (
            <SuggestedJourney selectedJourneys={selectedJourneys} setSelectedJourneys={setSelectedJourneys} />
          )}
        </Grid>

        <Grid style={{ display: 'flex' }}>
          {step > 1 && (
            <Button onClick={() => setStep((pre) => pre - 1)} variant="outlined">
              Back
            </Button>
          )}
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <>
              <Button onClick={() => setIsOpen(false)} variant="outlined">
                Cancel
              </Button>
              <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onNext}>
                {step !== 3 ? 'Next' : 'Save'}
              </Button>
            </>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
